import { useTranslation } from "react-i18next";

import { createFormHelper } from "lib/Form";

import type { CreateEditUserForm } from "modules/UsersDashboard/components";

type UserFormHeaderCheckboxesProps = {
  disabled: boolean;
};

const FormHelper = createFormHelper<CreateEditUserForm>();

export const UserFormHeaderCheckboxes = ({ disabled }: UserFormHeaderCheckboxesProps) => {
  const { t } = useTranslation();

  return (
    <div className="header-checkbox-container">
      <div>
        <FormHelper.Field.Checkbox name="is_combi_user" label={t("v8_combi_user", "Combi user")} disabled={disabled} />
      </div>
      <div>
        <FormHelper.Field.Checkbox name="has_leased_tablet" label={t("v8_lease_tablet", "Lease tablet")} disabled={disabled} />
      </div>
      <div>
        <FormHelper.Field.Checkbox name="isActive" label={t("v8_active", "Active")} disabled={disabled} />
      </div>
    </div>
  );
};
